import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { PROJECT_FORMS_LOCAL_API_REQUESTS } from './constants';

// GET projects/{projectId}/forms/by-type/{type}?nextToken=
// -> { Items: Form[], nextToken: string | null }
export const getProjectFormsByType = async ({ projectId, type, nextToken }) => {
  const apiPath = `projects/${projectId}/forms/by-type/${type}${
    nextToken ? `?nextToken=${encodeURIComponent(nextToken)}` : ''
  }`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: PROJECT_FORMS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
